import React, { Component } from "react";
import { Link } from "react-router-dom";
import * as routes from "../shared/routes";
import analytics from "../shared/analytics"

class SessionExpired extends Component {
    constructor(props) {
        super(props)
        analytics.pageView()
    }

    render() {
        return (
            <mosaic-content-container>
                <mosaic-main-container fluid>
                    <mosaic-card>
                        <mosaic-card-body>
                            <div >
                                <span>Session timed out.&nbsp;</span>
                                <Link to={routes.login}>Please log back in.</Link>
                            </div>
                        </mosaic-card-body>
                    </mosaic-card>
                </mosaic-main-container>
            </mosaic-content-container>
        )
    }
}

export default SessionExpired